import { getLanguageBaseOnTZ } from '../../../utils/LanguageLocalStorage';
import i18n from '../../../i18n';

export default {
  addReminder: 'افزودن یادآور',
  applyTemplateFailed: 'اعمال تغییرات بر وظایف با شکست روبرو شد',
  applyTemplateToPastTasks: 'اعمال کردن تغییرات قالب به وظایف قبلی',
  archived: 'بایگانی شده',
  areYouSure: 'آیا از انجام این کار مطمئن هستید؟',
  assigneeCompleteTitle: 'عنوان سفارشی وضعیت کار: انجام شده',
  assigneeCanEdit: 'انجام‌دهنده بتواند ویرایش کند',
  assigneeNotStartedTitle: 'عنوان سفارشی وضعیت کار: شروع نشده',
  assigneeStartedTitle: 'عنوان سفارشی وضعیت کار شروع شده',
  assigneeStateTitle: 'عنوان سفارشی کار',
  assigneeTitle: 'عنوان سفارشی انجام‌دهنده',
  defaultTitle: 'عنوان پیشفرض',
  cancel: 'لغو',
  chatTitle: 'عنوان سفارشی گفتگو',
  chooseVerifier: 'افزودن تأییدکننده',
  chooseTaskPublisher: 'افزودن منتشر کننده وظیفه پیشفرض',
  chooseSubTaskPublisher: 'افزودن منتشر کننده زیروظایف پیشفرض',
  chooseSubTemplates: 'افزودن زیرقالب',
  companyTemplates: 'قالب‌های شرکت',
  create: 'ساختن',
  createNewTemplate: 'ایجاد قالب',
  creationDate: 'تاریخ ایجاد',
  customTitles: 'عناوین سفارشی',
  dateAndTime: 'تاریخ‌ها با دقت ساعت باشد',
  defaultVerifier: 'تأییدکنندهٔ پیش‌فرض',
  defaultTaskPublisher: 'منتشر کننده وظیفه پیش‌فرض',
  defaultSubTaskPublisher: 'منتشر کننده زیروظایف پیش‌فرض',
  dueDate: 'مهلت انجام',
  dueDateTitle: 'عنوان سفارشی مهلت انجام',
  dueVerify: 'تاریخ تایید',
  effectiveDateType: 'نوع تاریخ موثر',
  fields: 'فیلدها',
  followerCanEdit: 'مطلع بتواند ویرایش کند',
  followersTitle: 'عنوان سفارشی مطلع',
  editTemplate: 'ویرایش قالب',
  haveConversation: 'گفتگو داشته باشد',
  haveDueDate: 'مهلت انجام داشته باشد',
  haveFollower: 'مطلع داشته باشد',
  haveAssignee: 'مجری داشته باشد',
  haveStartDate: 'تاریخ شروع داشته باشد',
  haveSubTask: 'گام داشته باشد',
  haveVerifier: 'تاییدکننده داشته باشد',
  haveVerifyDate: 'تاریخ تأیید داشته باشد',
  onlyVerifierCanMark: 'مجری بتواند وضعیت اجرا را تغییر بدهد',
  parentCreationDate: 'تاریخ ایجاد والد',
  parentDueDate: 'مهلت انجام والد',
  parentDueVerify: 'تاریخ تایید والد',
  parentStartDate: 'تاریخ شروع والد',
  progressiveOrNot: 'گزارش درصد انجام وظیفه',
  remindersConfig: 'پیکربندی یادآورها',
  printTemplateConfig: 'پیکربندی چاپ',
  save: 'ذخیره',
  showArchivedTemplates: 'نمایش قالب‌های بایگانی شده',
  showUnArchivedTemplates: 'نمایش قالب‌های غیر بایگانی شده',
  startDate: 'تاریخ شروع',
  startDateTitle: 'عنوان سفارشی تاریخ شروع',
  subTasksTitle: 'عنوان سفارشی ‌گام',
  subTemplates: 'زیرقالب‌ها',
  printTemplate: 'قالب چاپ',
  addPrintTemplate: 'قالب جدید را تایپ کنید...',
  suggestOnDocumentManager: 'پیشنهاد کردن این قالب در مدیریت محتوا',
  taskName: 'نام قالب',
  draft: 'ثبت به صورت پیشنویس',
  assigneeDefaultToProjectMembers: 'پیشفرض مجری کل افراد پروژه باشد',
  followerDefaultToProjectMembers: 'پیشفرض دنبال کنند‌گان کل افراد پروژه باشد',
  haveRelatedItem: 'دارای سند مرتبط',
  verifierCanMark: 'تایید کننده بتواند وضعیت اجرا را تغییر بدهد',
  singleInParent: 'در هر وظیفه فقط یک عدد از این نوع زیر وظیفه ساخته شود',
  continueOnSubTasks: 'بعد از ذخیره اولیه به تب زیر وظایف برود.',
  haveTaskPublisher: 'منتشر کننده وظیفه دارد',
  haveSubTaskPublisher: 'منتشر کننده زیر وظیفه دارد',
  onlyPublisherCanPublish: 'فقط منتشر کننده امکان انتشار دارد',
  allowDirectPublish: 'امکان انتشار مستقیم وظیفه',
  allowPublishSubtasks: 'امکان انتشار وظیفه به همراه زیر وظایف',
  taskPublisherTitle: 'عنوان منتشر کننده وظیفه',
  subTaskPublisherTitle: 'عنوان منتشر کننده زیر وظایف',
  readyToPublishTaskTitle: 'آماده انتشار',
  readyToPublishSubTaskTitle: 'وظیفه آماده انتشار زیر وظایف',
  copy: 'کپی این قالب',
  copied: 'کپی شد',
  noTemplateFount: 'قالب یافت نشد',
  pasted: 'جایگذاری انجام شد',
  chooseAssignee: 'انتخاب مجری',
  defaultAssignee: 'مجری پیشفرض',
  from: ' از ',
  header: 'سربرگ',
  body: 'محتوای اصلی',
  subTasks: 'زیر وظایف',
  StartTime: 'ساعت شروع',
  DueTime: 'ساعت پایان',
  rawPrintTemplate: 'تمپلیت خام',
  autoLockOnPublish: 'قفل وظیفه پس از انتشار',
  preventSubTaskCreationWhenDraft:
    'جلوگیری از ساخت زیروظیفه در صورت پیشنویس بودن',
  assignee: 'انجام دهنده',
  verifier: 'تاییدکننده',
  follower: 'دنبال کننده',
  publisher: 'منتشرکننده',
  subtaskPublisher: 'منتشرکننده زیروظیفه',
  relatedItem: 'سند مرتبط',
  compulsoryFields: 'فیلد های اجباری',
  templateCreated: 'قالب مورد نظر با موفقیت ایجاد شد',
  templateEditor: 'ویرایشگر قالب',
  templateList: 'فهرست قالب‌ها',
  templateType: 'نوع قالب',
  templateUpdated: 'قالب با موفقیت به‌روزرسانی شد.',
  thereIsNoTemplateYet: 'هنوز قالبی وجود ندارد.',
  useParentAssignees: 'استفاده از انجام‌دهنده‌های والد برای فرزند',
  useParentVerifier: 'استفاده از تایید کننده والد برای فرزند',
  haveWeight: 'دارای وزن',
  disallowQuickAdd: 'نمایش کامل وظیفه در هنگام اضافه کردن',
  allowQuickAdd: 'امکان ساخت پی در پی وظیفه',
  verifierCompleteTitle: 'عنوان سفارشی تأیید شده',
  verifierNotStartedTitle: 'عنوان سفارشی بررسی نشده',
  verifierRejectTitle: 'عنوان سفارشی رد شده',
  verifierStartedTitle: 'عنوان سفارشی وضعیت در حال بررسی',
  verifierTitle: 'عنوان سفارشی تأییدکننده',
  verifyDateTitle: 'عنوان سفارشی تاریخ تأیید',
  verifyStateTitle: 'عنوان سفارشی وضعیت بررسی',
  relatedProviderItemTitle: 'عنوان سفارشی سند مرتبط',
  undraftTaskTitle: 'عنوان سفارش ابلاغ وظیفه',
  undraftTaskAndSubtaskTitle: 'عنوان سفارشی ابلاغ وظیفه و زیر وظایف',
  addCreatorToFollowers:
    'سازنده یک وظیفه در لیست دنبال‌کنندگان به صورت پیش‌فرض اضافه شود',
  printParts: {
    ProjectName: 'عنوان پروژه',
    Verifier: 'تایید کننده',
    Follower: 'مطلع',
    Publisher: 'منتشر کننده',
    SubTaskPublisher: 'منتشر کننده زیر وظایف',
    ParentVerifier: 'تایید کننده والد',
    ParentFollower: 'مطلع والد',
    ParentPublisher: 'منتشر کننده والد',
    ParentSubTaskPublisher: 'منتشر کننده زیروظایف والد',
    StartDate: 'تاریخ شروع',
    StartTime: 'زمان شروع',
    StartDateTime: 'تاریخ و زمان شروع',
    DueDate: 'تاریخ پایان',
    DueTime: 'زمان پایان',
    Weight: 'وزن',
    DueDateTime: 'تاریخ و زمان پاین',
    ParentStartDate: 'تاریخ شروع والد',
    ParentStartTime: 'زمان شروع والد',
    ParentStartDateTime: 'تاریخ و زمان شروع والد',
    ParentDueDate: 'تاریخ پایان والد',
    ParentDueTime: 'زمان پایان والد',
    ParentDueDateTime: 'تاریخ و زمان پاین والد',
    DateCombo: 'بازه زمانی',
    ParentDateCombo: 'بازه زمانی والد',
    NewLine: 'خط جدید',
    Assignee: 'مجری',
    Subtasks: 'زیر وظایف',
    Signatures: 'امضاها',
    MainProgress: 'پیشرفت اصلی',
    RelatedProviderItem: 'سند مرتبط',
    SubTasksTitle: 'عنوان زیروظیفه',
    title: 'عنوان',
    SubTaskAndProgress: 'زیروظایف و پایش',
    parentTitle: 'عنوان والد',
    ancestorTitle: 'عنوان پدربزرگ',
    templateCreated: 'قالب مورد نظر با موفقیت ایجاد شد',
  },
  confirmPaste(templateName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa') {
      return `آیا مطمئن هستید که محتویات قالب «${templateName}» با تنظیمات کنونی جایگزین شود؟`;
    } else
      return `Are you sure you want to replace the contents of the template '${templateName}' with the current settings?`;
  },
  templateArchived(archived: boolean): string {
    const lang = getLanguageBaseOnTZ();
    if (archived) {
      return lang === 'fa'
        ? 'قالب مورد نظر با موفقیت بایگانی شد'
        : 'The selected template has been successfully archived';
    }
    return lang === 'fa'
      ? 'قالب مورد نظر با موفقیت بازیابی شد'
      : 'The selected template has been successfully restored';
  },
  templateChangesAppliedToTasks(num: number) {
    return i18n.t('templateChangesAppliedToTasks', {
      ns: 'companyManagement',
      num,
    });
  },
};
